import { mostrarMoneda } from '@/utils/utils.js'

export default {
    getSelectImpresoras(state) {
        let res = [];
        if (Array.isArray(state.impresorasNegocio)) {
            state.impresorasNegocio.forEach(imp => {
                let aux = {
                    id: imp.id,
                    mostrarSelect: imp.id + '-' + imp.name + '-' + imp.computer.name,
                    nombre: imp.name,
                    desc: imp.description,
                    computerName: imp.computer.name,
                    computerId: imp.computer.id
                }
                res.push(aux);
            });
        }
        return res;
    },
    getSelectOrdenadores(state) {
        let res = [];
        if (Array.isArray(state.ordenadoresNegocio)) {
            state.ordenadoresNegocio.forEach(pc => {
                let aux = {
                    id: pc.id,
                    mostrarSelect: pc.id + '-' + pc.name

                }
                res.push(aux);
            });
        }
        return res;
    },
    numPedidosNegocio(state, getters, rootState) {
        return rootState.pedidos.pedidosArray.length.toString();
    },
    numCantidad(state, getters, rootState) {
        return mostrarMoneda(rootState.pedidos.pedidosArray.reduce(function (a, { precioTotal }) {
            return a + precioTotal;
        }, 0));
    },
    numRestNegocio(state, getters, rootState) {
        return rootState.restaurantes.restaurantesArray.length.toString()
    },
    cantidadPedidosNegocio(state, getters, rootState) {
        return state.pedidosArray.reduce(function (a, b) {
            return b[total] == null ? a : a + b[total];
        }, 0);
    },
}